import { c as _c } from "react/compiler-runtime";
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, IconButton, Theme, Toolbar } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderContent from './HeaderContent';
import { config } from '../theme';
import { use } from 'react';
import { LayoutContext } from '..';
export interface HeaderProps {
  unauthorized?: boolean;
}
const Header = t0 => {
  const $ = _c(28);
  const {
    unauthorized
  } = t0;
  const {
    toggleDrawer,
    drawerOpen
  } = use(LayoutContext);
  const theme = useTheme();
  const t1 = drawerOpen ? "grey.300" : "grey.100";
  let t2;
  if ($[0] !== drawerOpen) {
    t2 = drawerOpen ? {
      xs: -1,
      lg: -2
    } : 0;
    $[0] = drawerOpen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      color: "text.primary",
      bgcolor: t1,
      ml: t2,
      mr: 2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drawerOpen) {
    t4 = !drawerOpen ? <MenuIcon /> : <MenuOpenIcon />;
    $[5] = drawerOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== toggleDrawer) {
    t5 = <IconButton disableRipple={true} aria-label="open drawer" onClick={toggleDrawer} color="primary" sx={t3}>{t4}</IconButton>;
    $[7] = t3;
    $[8] = t4;
    $[9] = toggleDrawer;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== unauthorized) {
    t6 = <HeaderContent unauthorized={unauthorized} />;
    $[11] = unauthorized;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Toolbar>{t5}{t6}</Toolbar>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const mainHeader = t7;
  let t8;
  if ($[16] !== drawerOpen || $[17] !== theme) {
    t8 = styles(theme, drawerOpen);
    $[16] = drawerOpen;
    $[17] = theme;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = t8.wrapper;
  let t10;
  if ($[19] !== drawerOpen || $[20] !== theme) {
    t10 = styles(theme, drawerOpen);
    $[19] = drawerOpen;
    $[20] = theme;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== mainHeader || $[23] !== t10.content) {
    t11 = <Box sx={t10.content}>{mainHeader}</Box>;
    $[22] = mainHeader;
    $[23] = t10.content;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t8.wrapper) {
    t12 = <AppBar elevation={0} sx={t9}>{t11}</AppBar>;
    $[25] = t11;
    $[26] = t8.wrapper;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default Header;
const styles = (theme: Theme, open: boolean) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    color: 'inherit',
    borderBottom: `1px solid ${theme.palette.divider}`,
    height: config.headerHeight,
    zIndex: theme.zIndex.drawer - 1,
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(2px)',
    boxShadow: '0 .125rem 9.375rem rgba(90,97,105,.1),0 .25rem .5rem rgba(90,97,105,.12),0 .9375rem 1.375rem rgba(90,97,105,.1),0 .4375rem 2.1875rem rgba(165,182,201,.1)'
  },
  content: {
    height: config.headerHeight,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    ...(open ? {
      marginLeft: config.drawerWidth + 'px',
      width: `calc(100% - ${config.drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    } : {
      width: '100%'
    })
  }
});